import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledCollapse, Card, CardHeader, CardBody } from 'reactstrap';
import { TablaCabecera } from './TablaCabecera';
import { TablaPromedios } from './TablaPromedios';
import { GraficoBarras } from './GraficoBarras';
import { GraficoBarrasApiladas } from './GraficoBarrasApiladas';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

export class Paralelo extends Component {
  static displayName = Paralelo.name;

  constructor(props) {
    super(props);
    this.state = { paralelo: null, datos: [], areas: [], frecuencias: [], alternativas: [], modo: "view", loading: true };
    //console.log(props.match);
    this.onDownloadPdf = this.onDownloadPdf.bind(this);
  }

  componentDidMount() {
    document.title = TITLE + " - Histórico por profesor";
    const anio = this.props.match.params["anio"];
    const termino = this.props.match.params["termino"];
    const codigo = this.props.match.params["codigo"];
    const paralelo = this.props.match.params["paralelo"];
    const identificacion = this.props.match.params["identificacion"];
    const modo = this.props.match.params["modo"] || "view";
    this.populateData(anio, termino, codigo, paralelo, identificacion, modo);
  }

  toggle(area) {
    const i = this.state.areas.indexOf(area);
    this.setState(({ areas }) => ({
      areas: [
        ...areas.slice(0, i),
        {
          ...areas[i],
          comparativo: !areas[i].comparativo,
        },
        ...areas.slice(i + 1)
      ]
    }));
  }

  formatter(valor) {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
  }

  splitwords(text, size = 40) {
    if (text.length <= size)
      return text;
    const chunks = text.split(" ");
    const parts = [];
    var aux = "";
    for (var c in chunks) {
      if (aux.length + chunks[c].length <= size) {
        aux += chunks[c] + " ";
      }
      else {
        parts.push(aux);
        aux = chunks[c] + " ";
      }
    }
    parts.push(aux);
    return parts;
  }

  onDownloadPdf() {
    const { paralelo } = this.state;
    fetch(`${APIURL}/api/reportes/reporte-paralelo-pdf/${paralelo.anio}/${paralelo.termino}/${paralelo.codigo}/${paralelo.paralelo}/${paralelo.cedula}`)
      .then(response => response.json())
      .then(data => {
        if (data) {
          let a = document.createElement("a");
          a.href = `data:application/pdf;base64,${data.result}`;
          a.download = `reporte-${paralelo.anio}-${paralelo.termino}-${paralelo.codigo}-${paralelo.paralelo}-${paralelo.cedula}.pdf`;
          a.click();
        }
      });
  }

  renderTable(paralelo, datos, areas, frecuencias, alternativas) {
    //console.log(datos);
    return (
      <>
        <TablaCabecera paralelo={paralelo} />
        {areas && areas.map((a) => {
          const preguntas = datos.filter(p => a.idarea == p.idarea);
          //const etiquetas = preguntas.map(p => this.splitwords(p.pregunta));
          const etiquetas = preguntas.map((p, index) => index+1);
          const valoresFrecuencias = frecuencias.filter(f => f.idarea == a.idarea).map(p => { return { ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa, frecuencia: p.frecuencia } });
          const valoresPuntaje = preguntas.map(p => this.formatter(p.porcentaje * 100));
          return (
            <div key={ "d_" + a.idarea }>
              <TablaPromedios key={"t_" + a.idarea} area={a} preguntas={preguntas} />
               {/*{' '}<Button onClick={() => this.toggle(a)}>Ver comparativo</Button><br /> */}
              {this.state.modo == "view" ?
                <>
                  <Button id={"tg_" + a.idarea}>Ver gráfico</Button>                
                  <UncontrolledCollapse toggler={'#tg_' + a.idarea}>
                    <Card>
                      <CardBody>
                        <GraficoBarrasApiladas key={"gf_" + a.idarea} titulo={a.area} labels={etiquetas} values={valoresFrecuencias} evaluados={paralelo.evaluados} />
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </>
                :
                <GraficoBarrasApiladas key={"gf_" + a.idarea} id={"gf_" + a.idarea} animation={false} titulo={a.area} labels={etiquetas} values={valoresFrecuencias} evaluados={paralelo.evaluados} />
              }
              <br />
              <Modal key={"m_" + a.idarea} isOpen={a.comparativo} className="modal-xl">
                <ModalHeader>Gráfico comparativo</ModalHeader>
                <ModalBody>
                  <GraficoBarras key={"g_" + a.idarea} title={a.area} labels={etiquetas} values={valoresPuntaje} respuestas={paralelo.evaluados} />
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={ () => this.toggle(a) }>
                    Cerrar
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
          );
        })}
        
      </>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderTable(this.state.paralelo, this.state.datos, this.state.areas, this.state.frecuencias, this.state.alternativas);

    return (
      <div className="d-flex">
        {/*<div className="text-end"><Button onClick={() => this.onDownloadPdf()}>Descargar PDF</Button></div>*/}
        
        <div>
          <h1 id="tabelLabel" className="text-center">Reporte por Paralelo</h1>
          {contents}
        </div>
      </div>
    );
  }

  async populateData(anio, termino, codigo, paralelo, identificacion, modo) {
    const response = await fetch(`${APIURL}/api/reportes/paralelo/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}`);
    const data = await response.json();

    const dataResponse = await fetch(`${APIURL}/api/reportes/paralelo-detalle/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}`);
    const dataParalelo = await dataResponse.json();
    const areas = [];
    dataParalelo.forEach(p => {
      if (areas.every(a => a.idarea !== p.idarea)) {
        areas.push({ idarea: p.idarea, area: p.area, comparativo:false });
      }
    });

    const frecuenciasResponse = await fetch(`${APIURL}/api/reportes/paralelo-frecuencias/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}`);
    const dataFrecuencias = await frecuenciasResponse.json();
    const alternativas = [];
    dataFrecuencias.forEach(p => {
      if (alternativas.every(e => e.ordenAlternativa !== p.ordenAlternativa)) {
        alternativas.push({ ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa });
      }
    });

    if (dataParalelo && dataFrecuencias) {
      this.setState({ paralelo: data, datos: dataParalelo, areas: areas, frecuencias: dataFrecuencias, alternativas: alternativas, modo: modo, loading: false });
    }
    
  }
}
